import React, { Component } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import { auth } from "../utils/auth";

import MobileHeader from "./general/MobileHeader";
import Sidebar from "./general/Sidebar";
import DesktopHeader from "./general/DesktopHeader";

import Login from "./Login";
import GIDashboard from "./HomeDashboard/GI/Dashboard";
import VendedoresDashboard from "./HomeDashboard/GI/VendedoresDashboard";
import Empleados from "./Empleados";
import Nominas from "./Nominas";
import ViewNomina from "./Nominas/View";
import CrearEmpleado from "./Empleados/Create";
import LayoutEmpleado from "./Empleados/Layout";
import Vehiculos from "./Vehiculos";
import Reclamaciones from "./Reclamaciones";
import CrearVehiculo from "./Vehiculos/Create";
import LayoutVehiculo from "./Vehiculos/Layout";
import Programaciones from "./Programaciones";
import Edit from "./Programaciones/Edit";
import Rutas from "./Rutas";
import Reportes from "./Consultas/Reportes";
import Usuarios from "./Configuracion/Usuarios";
import Tipos from "./Configuracion/Tipos";
import Ausencias from "./Ausencias";
import Vacaciones from "./Ausencias/Vacaciones";
import TipoAusencias from "./Configuracion/TipoAusencias";
import Categorias from "./Configuracion/Categorias";
import Asignaciones from "./Configuracion/Asignaciones";
import Solicitudes from "./Solicitudes";
import Sucursales from "./Configuracion/Sucursales";
import LayoutSucursales from "./Configuracion/Sucursales/Layout";
import Configuracion from "./Configuracion";
import Almacenes from "./Configuracion/Almacenes";
import Grupos from "./Configuracion/Grupos";
import Ubicaciones from "./Configuracion/Ubicaciones";
import Cuentas from "./Cuentas";
import LayoutCuentas from "./Cuentas/Layout";
import Productos from "./Productos";
import CreateProducto from "./Productos/Create";
import LayoutProducto from "./Productos/Layout";
import Items from "./Items";
import CreateItem from "./Items/Create";
import LayoutItem from "./Items/Layout";
import Servicios from "./Servicios";
import Gastos from "./Gastos";
import CrearGastos from "./Gastos/CreateMultiple";
import GastosGenerales from "./GastosGenerales";
import CrearGastosGenerales from "./GastosGenerales/Create";
import Contactos from "./Contactos";
import Compras from "./Compras";
import EditCompras from "./Compras/Edit";
import CrearCompras from "./Compras/Create";
import ComprasRecurrentes from "./ComprasRecurrentes";
import CreateCompraRecurrente from "./ComprasRecurrentes/Create";
import EditCompraRecurrente from "./ComprasRecurrentes/Edit";
import Modal from "./general/Modal";
import DescuentosProgramados from "./DescuentosProgramados";
import Incentivos from "./Incentivos";
import GIPrestamos from "./GI/Prestamos";
import GIGrupos from "./GI/Grupos";
import GIServidores from "./GI/Servidores";
import GIGruposCrear from "./GI/Grupos/Create";
import GIGruposLayout from "./GI/Grupos/Layout";
import GrupoTipoEmpleados from "./GrupoTipoEmpleados";
import Facturas from "./Ingresos/Facturacion";
import CrearFactura from "./Ingresos/Facturacion/Create";
import EditFactura from "./Ingresos/Facturacion/Edit";
import Pedidos from "./Ingresos/Pedidos";
import CrearPedido from "./Ingresos/Pedidos/Create";
import EditPedido from "./Ingresos/Pedidos/Edit";
import OrdenesCompra from "./OrdenCompra";
import CrearOrdenCompra from "./OrdenCompra/Create";
import EditOrdenCompra from "./OrdenCompra/Edit";
import Cotizaciones from "./Ingresos/Cotizacion";
import CrearCotizacion from "./Ingresos/Cotizacion/Create";
import EditCotizacion from "./Ingresos/Cotizacion/Edit";
import Numeraciones from "./Configuracion/Numeraciones";
import TerminosPago from "./Configuracion/TerminosPago";
import Impuestos from "./Configuracion/Impuestos";
import Taxonomias from "./Configuracion/Taxonomias";
import Unidades from "./Configuracion/Unidades";
import Academica from "./Configuracion/Academica";
import GastosInternos from "./GastosInternos";
import GastosInternosCrear from "./GastosInternos/Create";
import GastosInternosEditar from "./GastosInternos/Edit";
import PlantillaImpresion from "./Configuracion/PlantillaImpresion";
import ContactosTransaccionesHistory from "./Contactos/Transacciones/History";
import ContactosTransaccionesCompras from "./Contactos/Transacciones/Compras";
import CuentasPorCobrar from "./Consultas/CuentasPorCobrar";
import RecibosIngreso from "./Consultas/RecibosIngresos";
import FacturasRecurrentes from "./Ingresos/FacturacionRecurrente";
import CrearFacturaRecurrente from "./Ingresos/FacturacionRecurrente/Create";
import EditFacturaRecurrente from "./Ingresos/FacturacionRecurrente/Edit";
import HistorialPagosFacturas from "./Consultas/HistorialPagosFacturas";
import Estudiantes from "./Academico/Estudiantes";
import CrearEstudiante from "./Academico/Estudiantes/Create";
import EditarEstudiante from "./Academico/Estudiantes/Edit";
import Evaluaciones from "./Academico/Evaluaciones";
import Inscripciones from "./Academico/Inscripciones";
import Tutores from "./Academico/Tutores";
import CrearTutor from "./Academico/Tutores/Create";
import FacturacionAcademica from "./Academico/FacturacionAcademica/Create";
import RecibosAcademicos from "./Academico/Recibos";
import RecibosCocurriculares from "./Academico/Cocurriculares/Recibos";
import Cocurriculares from "./Academico/Cocurriculares/Create";
import InscripcionCocurriculares from "./Academico/Cocurriculares/Inscripcion";
import LayoutTutor from "./Academico/Tutores/Layout";
import CuentasPorPagar from "./Consultas/CuentasPorPagar";
import CuentasContables from "./CuentasContables";
import EntradasDiario from "./EntradasDiario";
import CrearEntradasDiario from "./EntradasDiario/Create";
import EditarEntradasDiario from "./EntradasDiario/Edit";
import NotasCredito from "./Consultas/NotasCredito";
import CreateNotaCredito from "./Consultas/NotasCredito/CreateNotaCredito";
import RazonesNotasCredito from "./Configuracion/RazonesNotasCredito";
import EditNotaCredito from "./Consultas/NotasCredito/EditNotaCredito";

import NotasCreditoCompras from "./NotasCreditoCompra";
import CreateNotaCreditoCompra from "./NotasCreditoCompra/CreateNotaCredito";
import EditNotaCreditoCompra from "./NotasCreditoCompra/EditNotaCredito";

import Cheques from "./Cheques";
import Contratos from "./Contratos";
import TipoContratos from "./Configuracion/Contratos"
import { permisions } from "../utils/helpers";
import Salud from "./Salud";
import Visitas from "./Salud/Visitas";
import VisitaCreate from "./Salud/Visitas/Create";
import VisitaEdit from "./Salud/Visitas/Edit";
import Pacientes from "./Salud/Pacientes";
import PacienteView from "./Salud/Pacientes/View";
import InventarioSalud from "./Salud/Inventario";
import InsumoCreate from "./Salud/Inventario/Create";
import InsumoEdit from "./Salud/Inventario/Edit";
import ConfiguracionSalud from "./Configuracion/Salud";
import Templates from "./Cartas/Templates";
import TemplateCreate from "./Cartas/CreateTemplate";
import TemplateEdit from "./Cartas/EditTemplate";
import Cartas from "./Cartas";
import Reset from "./Configuracion/TipoAusencias/Reset";
import DespachoFacturas from "./Ingresos/DespachoFacturas";
import CuadreCaja from "./Ingresos/CuadreCaja";
import MainView from "./MainView";
import InventarioMasivo from "./Productos/InventarioMasivo";
import CreateInventarioMasivo from "./Productos/InventarioMasivo/Create";
import EditarInventarioMasivo from "./Productos/InventarioMasivo/Edit";
import NotasDebito from "./Ingresos/NotasDebito";
import CreateNotasDebito from "./Ingresos/NotasDebito/Create";
import EditNotasDebito from "./Ingresos/NotasDebito/Edit";

class Dashboard extends Component {
    state = {
        isLoggedIn: auth.isLoggedIn(),
        showReportes: false,
        // Drawer del sidebar en móvil. Antes esto era un classList.add('d-none')
        // imperativo repartido entre MobileHeader y este componente.
        sidebarMovilAbierto: false,
    };
    componentDidMount() {
        window.addEventListener("storage", this.syncLogout);

        // auth.inactivityTime();
    }
    componentWillUnmount() {
        window.removeEventListener("storage", this.syncLogout);
        window.localStorage.removeItem("logout");
    }
    syncLogout = (event) => {
        if (event.key === "logout") {
            this.setState({ isLoggedIn: auth.isLoggedIn() });
        }
    };
    toggleModal = (modal, show = null) => {
        this.setState({
            [modal]: show === null ? !this.state[modal] : show,
        });
    };
    abrirSidebarMovil = () => this.setState({ sidebarMovilAbierto: true });

    cerrarSidebarMovil = () => {
        if (!this.state.sidebarMovilAbierto) return;

        this.setState({ sidebarMovilAbierto: false });
    };

    componentDidUpdate(prevProps, prevState) {
        if (auth.isLoggedIn()) {

            console.log('Pendo Initialized.')
        }
    }

    render() {
        if (!this.state.isLoggedIn) return <Login />;

        const user = auth.getUser();
        const account = user.sucursales.filter(
            (suc) => suc.id === user.sucursalActual
        )[0];

        window.pendo?.initialize({
            visitor: {
                id: auth.getUser().id,
                email: auth.getUser().email,
            },
            account: {
                id: auth.getUser().sucursalActual,
                accountName: auth.getUser().sucursalActualName,
            }
        });

        const sucursal = auth.getUser().sucursalActual;

        return (
            <div>
                <MobileHeader abrirSidebar={this.abrirSidebarMovil} />
                <Sidebar
                    toggleModal={this.toggleModal}
                    movilAbierto={this.state.sidebarMovilAbierto}
                    cerrarMovil={this.cerrarSidebarMovil}
                />
                <div className='page-container' onClick={this.cerrarSidebarMovil}>
                    <DesktopHeader toggleModal={this.toggleModal} />
                    <div className='main-content'>
                        <div className='section__content section__content--p30'>
                            <div className='container-fluid'>
                                <Routes>
                                    <Route
                                        path="/"
                                        element={
                                            <NavegarConOrigen
                                                to={`/${sucursal}`}
                                            />
                                        }
                                    />
                                    <Route
                                        path='/:sucursal'
                                        element={<MainView />}
                                    />

                                    {/* <---SUCURSALES---> */}
                                    <Route
                                        path='/:sucursal/sucursales'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.editarSucursales)}>
                                                <Sucursales />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/sucursales/:id/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.editarSucursales)}>
                                                <LayoutSucursales />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---Salud---> */}
                                    <Route
                                        path='/:sucursal/salud'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.salud)}>
                                                <Salud />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/salud/visitas'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.visitaSalud)}>
                                                <Visitas />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/salud/visitas/crear'
                                        element={
                                            <ProtectedRoute can={auth.canEdit(permisions.visitaSalud)}>
                                                <VisitaCreate />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/salud/visitas/:id'
                                        element={
                                            <ProtectedRoute can={auth.canEdit(permisions.visitaSalud)}>
                                                <VisitaEdit />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/salud/pacientes'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.pacientes)}>
                                                <Pacientes />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/salud/pacientes/:id'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.pacientes)}>
                                                <PacienteView />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/salud/inventario'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.inventarioSalud)}>
                                                <InventarioSalud />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/salud/inventario/crear'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.inventarioSalud)}>
                                                <InsumoCreate />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/salud/inventario/:id'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.inventarioSalud)}>
                                                <InsumoEdit />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---Académico---> */}
                                    <Route
                                        path='/:sucursal/academico/estudiantes'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verAcademico)}>
                                                <Estudiantes />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/academico/estudiantes/crear'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verAcademico)}>
                                                <CrearEstudiante />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/academico/estudiantes/:id/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verAcademico)}>
                                                <EditarEstudiante />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/academico/evaluaciones/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verAcademico)}>
                                                <Evaluaciones />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/academico/inscripcion'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verAcademico)}>
                                                <Inscripciones />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/academico/padres-tutores'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verAcademico)}>
                                                <Tutores />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/academico/padres-tutores/crear'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verAcademico)}>
                                                <CrearTutor />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/academico/facturar'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verAcademico)}>
                                                <FacturacionAcademica />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/academico/recibos'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verAcademico)}>
                                                <RecibosAcademicos />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/academico/inscripcion-cocurriculares'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verAcademico)}>
                                                <InscripcionCocurriculares />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/academico/cocurriculares'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verAcademico)}>
                                                <Cocurriculares />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/academico/recibos-cocurriculares'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verAcademico)}>
                                                <RecibosCocurriculares />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/academico/padres-tutores/:id/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verAcademico)}>
                                                <LayoutTutor />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---EMPLEADOS---> */}
                                    <Route
                                        path='/:sucursal/empleados'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verEmpleados)}>
                                                <Empleados />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ausencias'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verAusencias)}>
                                                <Ausencias />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/vacaciones'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verAusencias)}>
                                                <Vacaciones />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/empleados/crear'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verEmpleados)}>
                                                <CrearEmpleado />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/empleados/:id/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verEmpleados)}>
                                                <LayoutEmpleado />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/grupo-tipos-empleados/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verGrupoTiposEmpleados)}>
                                                <GrupoTipoEmpleados />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* Cartas */}
                                    <Route
                                        path='/:sucursal/cartas/letters'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCartas)}>
                                                <Cartas />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/cartas/plantillas'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCartas)}>
                                                <Templates />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/cartas/plantillas/create'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCartas)}>
                                                <TemplateCreate />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/cartas/plantillas/:id'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCartas)}>
                                                <TemplateEdit />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---GI GRUPOS---> */}
                                    <Route
                                        path='/:sucursal/gi-grupos'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verGiGrupos)}>
                                                <GIGrupos />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/gi-grupos/:id/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verGiGrupos)}>
                                                <GIGruposLayout />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/gi-prestamos'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verGiPrestamos)}>
                                                <GIPrestamos />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/gi-grupos/crear'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verGiGrupos)}>
                                                <GIGruposCrear />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/gi-servidores'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verGiServidores)}>
                                                <GIServidores />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---NOMINA---> */}
                                    <Route
                                        path='/:sucursal/nomina'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verNomina)}>
                                                <Nominas />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/nomina/:id'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verNomina)}>
                                                <ViewNomina />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---SOLICITUDES---> */}
                                    <Route
                                        path='/:sucursal/solicitudes'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verSolicitudes)}>
                                                <Solicitudes />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---RECLAMACIONES---> */}
                                    <Route
                                        path='/:sucursal/reclamaciones/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verReclamaciones)}>
                                                <Reclamaciones />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---DESCUENTOS---> */}
                                    <Route
                                        path='/:sucursal/descuentos/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verDescuentos)}>
                                                <DescuentosProgramados />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---INCENTIVOS---> */}
                                    <Route
                                        path='/:sucursal/incentivos/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verIncentivos)}>
                                                <Incentivos />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---SERVICIOS---> */}
                                    <Route
                                        path='/:sucursal/servicios'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verServicios)}>
                                                <Servicios />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---VEHICULOS---> */}
                                    <Route
                                        path='/:sucursal/vehiculos/crear/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verVehiculos)}>
                                                <CrearVehiculo />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/vehiculos/:id/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verVehiculos)}>
                                                <LayoutVehiculo />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/vehiculos'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verVehiculos)}>
                                                <Vehiculos />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---RUTAS---> */}
                                    <Route
                                        path='/:sucursal/rutas/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verRutas)}>
                                                <Rutas />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---REPORTES---> */}
                                    <Route
                                        path='/:sucursal/reportes/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verReportes)}>
                                                <Reportes />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---PROGRAMACION---> */}
                                    <Route
                                        path='/:sucursal/programaciones'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verProgramacion)}>
                                                <Programaciones />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/programaciones/:id'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verProgramacion)}>
                                                <Edit />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---INVENTARIO---> */}
                                    <Route
                                        path='/:sucursal/inventario'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verInventario)}>
                                                <Items />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/inventario/:id/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verInventario)}>
                                                <LayoutItem />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/inventario/crear/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.crearActivoFijo) || auth.can(permisions.editarActivoFijo)}>
                                                <CreateItem />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/productos'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verProductos)}>
                                                <Productos />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/productos/inventario-masivo'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verProductos)}>
                                                <InventarioMasivo />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/productos/inventario-masivo/create'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verProductos)}>
                                                <CreateInventarioMasivo />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/productos/inventario-masivo/:id'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verProductos)}>
                                                <EditarInventarioMasivo />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/productos/:id/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verProductos)}>
                                                <LayoutProducto />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/productos/crear/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verProductos)}>
                                                <CreateProducto />
                                            </ProtectedRoute>
                                        }
                                    />


                                    <Route
                                        path='/:sucursal/ordenes-compra'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verOrdenesCompra)}>
                                                <OrdenesCompra />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ordenes-compra/crear'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verOrdenesCompra)}>
                                                <CrearOrdenCompra />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ordenes-compra/:id/edit'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verOrdenesCompra)}>
                                                <EditOrdenCompra />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---GASTOS---> */}
                                    <Route
                                        path='/:sucursal/gastos'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verGastos)}>
                                                <Gastos />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/gastos-internos'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verGastos)}>
                                                <GastosInternos />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/gastos-internos/crear'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verGastos)}>
                                                <GastosInternosCrear />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/gastos-internos/:id/editar'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verGastos)}>
                                                <GastosInternosEditar />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/gastos/crear/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verGastos)}>
                                                <CrearGastos />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/gastos-generales'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verGastosGenerales)}>
                                                <GastosGenerales />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/gastos-generales/crear/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verGastosGenerales)}>
                                                <CrearGastosGenerales />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---COMPRAS---> */}
                                    <Route
                                        path='/:sucursal/compras'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCompras)}>
                                                <Compras />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/compras/crear'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCompras)}>
                                                <CrearCompras />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/compras/:id'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCompras)}>
                                                <EditCompras />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* Compras Reccurrentes */}
                                    <Route
                                        path='/:sucursal/compras-recurrentes'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCompras)}>
                                                <ComprasRecurrentes />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/compras-recurrentes/crear'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCompras)}>
                                                <CreateCompraRecurrente />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/compras-recurrentes/:id/editar'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCompras)}>
                                                <EditCompraRecurrente />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---CONTACTOS---> */}
                                    <Route
                                        path='/:sucursal/contactos'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verContactos)}>
                                                <Contactos />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/contactos/:id/transacciones'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verContactos)}>
                                                <ContactosTransaccionesHistory />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/contactos/:id/compras'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verContactos)}>
                                                <ContactosTransaccionesCompras />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---CONFIGURACIÓN---> */}
                                    <Route
                                        path='/:sucursal/configuracion/usuarios/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verConfiguracion)}>
                                                <Usuarios />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verConfiguracion)}>
                                                <Configuracion />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion/academica/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verConfiguracion)}>
                                                <Academica />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion/salud/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.salud)}>
                                                <ConfiguracionSalud />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion/tipos/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verTipos)}>
                                                <Tipos />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion/tipo-ausencias/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verConfiguracion)}>
                                                <TipoAusencias />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion/reset-pendiente-vacaciones/*'
                                        element={
                                            <ProtectedRoute can={auth.is("super-admin")}>
                                                <Reset />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion/categorias/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verVehiculos)}>
                                                <Categorias />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion/asignaciones/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verConfiguracion)}>
                                                <Asignaciones />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion/almacenes/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verAlmacenes)}>
                                                <Almacenes />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion/grupos/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCategorias)}>
                                                <Grupos />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion/ubicaciones/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verUbicaciones)}>
                                                <Ubicaciones />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion/numeraciones/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verConfiguracion)}>
                                                <Numeraciones />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion/terminos-pago/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verConfiguracion)}>
                                                <TerminosPago />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion/impuestos/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verConfiguracion)}>
                                                <Impuestos />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion/taxonomias/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verConfiguracion)}>
                                                <Taxonomias />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion/unidades/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verConfiguracion)}>
                                                <Unidades />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion/plantillas-impresion'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verPlantillasImpresion)}>
                                                <PlantillaImpresion />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion/razones-notas-credito'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verConfiguracion)}>
                                                <RazonesNotasCredito />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---CUENTAS---> */}
                                    <Route
                                        path='/:sucursal/cuentas'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCuentas)}>
                                                <Cuentas />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/cuentas/:id/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCuentas)}>
                                                <LayoutCuentas />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---INGRESOS---> */}
                                    <Route
                                        path='/:sucursal/ingresos/facturas'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verFacturas)}>
                                                <Facturas />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ingresos/facturas/crear'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verFacturas)}>
                                                <CrearFactura />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ingresos/facturas/crear/:plantilla'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verFacturas)}>
                                                <CrearFactura />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ingresos/facturas/:plantilla/duplicar'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verFacturas)}>
                                                <CrearFactura duplicar />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ingresos/facturas/:id/edit'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verFacturas)}>
                                                <EditFactura />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/ingresos/facturas-recurrentes'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verFacturasRecurrentes)}>
                                                <FacturasRecurrentes />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ingresos/facturas-recurrentes/crear'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verFacturasRecurrentes)}>
                                                <CrearFacturaRecurrente />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ingresos/facturas-recurrentes/:id/edit'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verFacturasRecurrentes)}>
                                                <EditFacturaRecurrente />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/ingresos/pedidos'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verPedidos)}>
                                                <Pedidos />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ingresos/pedidos/crear'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verPedidos)}>
                                                <CrearPedido />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ingresos/pedidos/:id/edit'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verPedidos)}>
                                                <EditPedido />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ingresos/cotizaciones'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCotizaciones)}>
                                                <Cotizaciones />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ingresos/cotizaciones/crear'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCotizaciones)}>
                                                <CrearCotizacion />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ingresos/cotizaciones/:id/edit'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCotizaciones)}>
                                                <EditCotizacion />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---CONTRATOS---> */}
                                    <Route
                                        path='/:sucursal/contratos'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verContratos)}>
                                                <Contratos />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/configuracion/contratos/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verTipos)}>
                                                <TipoContratos />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* <---CONSULTAS---> */}
                                    {/* <Route
                                        path='/:sucursal/consultas/reportes'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verReportes)}>
                                                <Reportes />
                                            </ProtectedRoute>
                                        }
                                    /> */}
                                    <Route
                                        path='/:sucursal/consultas/cuentas-por-cobrar'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCuentasPorCobrar)}>
                                                <CuentasPorCobrar />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/consultas/cuentas-por-pagar'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCuentasPorPagar)}>
                                                <CuentasPorPagar />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/consultas/recibos'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verRecibosIngreso)}>
                                                <RecibosIngreso />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ingresos/notas-credito'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verNotasCredito)}>
                                                <NotasCredito />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ingresos/notas-credito/crear'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verNotasCredito)}>
                                                <CreateNotaCredito />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ingresos/notas-credito/:id/editar'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verNotasCredito)}>
                                                <EditNotaCredito />
                                            </ProtectedRoute>
                                        }
                                    />



                                    <Route
                                        path='/:sucursal/ingresos/notas-debito'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verNotasDebito)}>
                                                <NotasDebito />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ingresos/notas-debito/crear'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verNotasDebito)}>
                                                <CreateNotasDebito />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ingresos/notas-debito/:id/editar'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verNotasDebito)}>
                                                <EditNotasDebito />
                                            </ProtectedRoute>
                                        }
                                    />




                                    <Route
                                        path='/:sucursal/egresos/notas-credito'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verNotasCredito)}>
                                                <NotasCreditoCompras />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/egresos/notas-credito/crear'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verNotasCredito)}>
                                                <CreateNotaCreditoCompra />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/egresos/notas-credito/:id/editar'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verNotasCredito)}>
                                                <EditNotaCreditoCompra />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/consultas/historial-pagos-facturas/:id'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verFacturas)}>
                                                <HistorialPagosFacturas />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ingresos/cuadre-caja'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verCuadreCaja)}>
                                                <CuadreCaja />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/ingresos/despacho-facturas'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verDespachoFacturas)}>
                                                <DespachoFacturas />
                                            </ProtectedRoute>
                                        }
                                    />

                                    <Route
                                        path='/:sucursal/cuentas-contables'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verContabilidad)}>
                                                <CuentasContables />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/entradas-de-diario'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verContabilidad)}>
                                                <EntradasDiario />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/entradas-de-diario/crear'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verContabilidad)}>
                                                <CrearEntradasDiario />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/entradas-de-diario/:id'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verContabilidad)}>
                                                <EditarEntradasDiario />
                                            </ProtectedRoute>
                                        }
                                    />
                                    <Route
                                        path='/:sucursal/cheques/*'
                                        element={
                                            <ProtectedRoute can={auth.can(permisions.verContabilidad)}>
                                                <Cheques />
                                            </ProtectedRoute>
                                        }
                                    />

                                    {/* REDIRECT WHEN PAGE DOESN'T EXISTS */}
                                    {auth.is("vendedor") ? (
                                        <Route path="*" element={<Navigate to={`/${sucursal}/ingresos/pedidos`} replace />} />
                                    ) : auth.is("vendedor-factura") || auth.is("vendedor-factura-orden_compra") ? (
                                        <Route path="*" element={<Navigate to={`/${sucursal}/ingresos/facturas`} replace />} />
                                    ) : (
                                        <Route path="*" element={<Navigate to={`/${sucursal}`} replace />} />
                                    )}
                                </Routes>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

/**
 * En v5 esto envolvía un <Route render>; v7 sólo acepta <Route> como hijo de
 * <Routes>, así que ahora es un envoltorio que va dentro de `element`:
 *
 *   <Route path='...' element={<ProtectedRoute can={...}><X /></ProtectedRoute>} />
 *
 * Los destinos de la redirección no llevan prefijo de sucursal, igual que en
 * v5: caen en la ruta comodín de abajo, que sí lo añade.
 */
function ProtectedRoute({ children, can }) {
    const location = useLocation();

    if (can) return children;

    const destino = auth.is("vendedor")
        ? "/ingresos/pedidos"
        : auth.is("vendedor-factura") || auth.is("vendedor-factura-orden_compra")
        ? "/ingresos/facturas"
        : "/";

    return <Navigate to={destino} state={{ from: location }} replace />;
}

/** Equivalente de `<Redirect to={{pathname, state: {from: location}}} />`. */
function NavegarConOrigen({ to }) {
    const location = useLocation();

    return <Navigate to={to} state={{ from: location }} replace />;
}

export default Dashboard;
